import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { logOut } from "../../utils/login";
import { useToasts } from "react-toast-notifications";
import { alphaList } from "../../utils/functions";

import ModalAvertissement from "./ModalAvertissement";

import { MDBIcon, MDBBtn } from "mdbreact";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function Marques() {
  const [marques, setMarques] = useState();
  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);
  const loggedIn = useSelector((state) => state.login);
  const [showAvertissement, setShowAvertissement] = useState(false);

  const { addToast } = useToasts();
  const history = useHistory();
  const dispatch = useDispatch();
  const handleShowAvertissement = () => setShowAvertissement(true);

  useEffect(() => {
    function getMarques() {
      axios
        .get(`${API_URL}/api/marques/marques-travaillees`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => res.data)
        .then((data) => {
          setMarques(alphaList(data));
        })
        .catch((e) => {
          if (e.response.status === 401) {
            addToast("Votre session est expirée. Merci de vous reconnecter.", {
              appearance: "warning",
              autoDismiss: true,
            });
            logOut();
            dispatch({ type: "LOGOUT" });
            history.push("/login");
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }
    if (loggedIn) {
      getMarques();
    }
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Mes marques</title>
      </Helmet>
      <h1>Mes marques</h1>
      {loggedIn ? (
        <Link to="gestion-des-marques">
          <MDBBtn color="primary">
            <MDBIcon icon="edit" /> Gérer mes marques
          </MDBBtn>
        </Link>
      ) : (
        <MDBBtn color="primary" onClick={handleShowAvertissement}>
          <MDBIcon icon="edit" /> Gérer mes marques
        </MDBBtn>
      )}
      <ul className="listContainer">
        {marques ? (
          Object.keys(marques).map((key) => (
            <div className="oneLetterContainer">
              <h2>{key}</h2>
              {marques[key].map((marque) => (
                <li key={marque.id}>
                  <Link to={`/fournisseurs-montures/${marque.fournisseur_id}`}>
                    {marque.nom}
                  </Link>
                </li>
              ))}
            </div>
          ))
        ) : (
          <p>
            {" "}
            Cette page est vide. Vous pouvez y faire apparaître les marques que
            vous travaillez en cliquant sur “gérer mes marques”.
            <br />
            Cochez alors les marques que vous souhaitez afficher et cliquez sur
            “Enregistrer” en bas de page. Vous pourrez ensuite à tout moment
            retrouver votre sélection.
          </p>
        )}
      </ul>
      <ModalAvertissement
        showAvertissement={showAvertissement}
        setShowAvertissement={setShowAvertissement}
      />
    </div>
  );
}

export default Marques;
